import {InjectionToken} from "@angular/core";

export interface KeycloakRuntimeConfig {
  url: string;
  realm: string;
  clientId: string;
}

export const KEYCLOAK_CONFIG = new InjectionToken<KeycloakRuntimeConfig>('KEYCLOAK_CONFIG');

